import { PopoverController } from '@ionic/angular';
import { Component, OnInit, Input } from '@angular/core';
import { AccountInformationService } from 'src/app/services/account-information/account-information.service';
import { BookingService } from 'src/app/services/booking/booking.service';
import { environment } from 'src/environments/environment';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-booking-popover',
  templateUrl: './booking-popover.page.html',
  styleUrls: ['./booking-popover.page.scss'],
})
export class BookingPopoverPage implements OnInit {
  s3_url: string = environment.s3_bucket_url;
  subscription = new SubSink();

  @Input() booking_id: number;

  profilePlaceholder: string = '/assets/images/profile-placeholder.png';

  bookingDetails: any;
  profile_image: string = null;
  account_name: string = null;
  category: string = null;
  booking_email: string = null;
  price_range: string = null;
  location: string = null;
  distance: string = null;
  price_negotiable: string = null;
  userId: string = null;

  user_profile: any;
  showSpinner: boolean = false;

  constructor(
    private bookingService: BookingService,
    private accountInfoService: AccountInformationService,
    private popover: PopoverController
  ) { }

  ngOnInit() {
    this.getBookingDetails(this.booking_id);
    this.getUserProfileData();
  }

  getBookingDetails(id) {
    this.subscription.sink = this.bookingService.getBookingDetails(id).subscribe(
      (res: any) => {
        this.bookingDetails = res.data;
        console.log("booking details --> ",this.bookingDetails);
        this.setBookingDetails(this.bookingDetails);
      },
      (error) => console.log(error)
    );
  }

  setBookingDetails(bookingDetails) {
    this.profile_image = bookingDetails.user.user_account_information?.profile_image;
    this.account_name = bookingDetails.user.first_name + ' ' + bookingDetails.user.last_name;
    this.category = bookingDetails.category;
    this.booking_email = bookingDetails.booking_email;
    this.price_range = '$' + bookingDetails.price_range_from + ' - ' + '$' + bookingDetails.price_range_to;
    this.location = bookingDetails.user.user_contact_information !== null ? bookingDetails.user?.user_contact_information?.us_city.city + ',' + bookingDetails.user?.user_contact_information?.us_state.state_code : 'N/A';
    this.distance = bookingDetails.distance;
    this.price_negotiable = bookingDetails.price_negotiable;
    this.userId = bookingDetails.user_id;
  }

  getUserProfileData() {
    this.user_profile = this.accountInfoService.getUserProfile();
    // console.log("user --> ",this.user_profile)
  }

  bookNow(booking_id) {
    this.showSpinner = true;
    let data = {
      booking_id: booking_id,
      profile_id: this.userId,
      encoded_user_id: btoa(this.user_profile.id)
    }
    this.subscription.sink = this.bookingService.bookNow(data).subscribe(
      (res: any) => {
        // console.log("book now response --> ",res);
        this.showSpinner = false;
        this.popover.dismiss({
          data: 'Request sent'
        });
      },
      (error) => {
        this.showSpinner = false;
        console.log(error)
      }
    );
  }

  closePopover() {
    this.popover.dismiss();
  }

}
